<template>
  <div class="col-xs-12 p-x-0">
    <menu-list
      :menu="menu"
      :schema="schema"
      :showMenuIcon="showMenuIcon"
      :getElement="getElement"
      :changeToProductList="changeToProductList"
      :checkDisableItem="checkDisableItem"
      :layout="layout"
      :showProductIcon="showProductIcon"
      :checkLowerPrice="checkLowerPrice"
      :getLower="getLower"
      :openModal="openModal"
      :getIcon="getIcon"
      :getTempE="getTempE"
      :prodImgList="prodImgList"
    />
  </div>
</template>
<script>
// import parse file
import parse from '../../../../assets/js/parse-menu.js'

import MenuList from './MenuList.vue'
export default {
  props: {
    type: String,
    menu: Object,
    schema: Object,
    layout: [Number, Boolean],
    showProductIcon: [Number, Boolean],
    changeToProductList: Function,
    checkDisableItem: Function,
    openModal: Function,
    getIcon: Function,
    isSearch: Boolean,
    showMenuIcon: [Boolean, Number],
    loading: Object,
    minPrice: Object,
    prodImgList: Object
  },
  data () {
    return {
    }
  },
  components: {
    'menu-list': MenuList
  },
  methods: {
    getProduct (productId) {
      return this.menu.productList[productId]
    },
    changeToCombineList (number) {
      return this.menu.combineList[number]
    },
    getElement (list, index) {
      var element
      // price
      if (index === 2) {
        element = 0
        for (var i = 0; i < list.length; i++) {
          element = element + parseInt(list[i][index])
        }
      } else if (index === 1) {
        // warm
        element = 0
        for (var k = 0; k < list.length; k++) {
          var t = list[k][index]
          if (t === 41 || t === 42 || t === 43 ||
              t === 44 || t === 45 || t === 46 ||
              t === 47 || t === 48 || t === 49) {
            element = element + parseInt(list[k][index])
          }
        }
      } else {
        // other element
        element = ''
        for (var j = 0; j < list.length; j++) {
          element = list[j][index]
        }
      }
      return element
    },
    getLower (result) {
      var pSchema = this.schema.product
      var prod = this.getProduct(result)
      var price = [prod[pSchema.name], 0, prod[pSchema.price], 3]
      if (prod[pSchema.type] === 3) {
        return [[price]]
      } else {
        return this.checkLowerPrice(this.parsePrice(result), result)
      }
    },
    checkLowerPrice (priceList, number) {
      var priceHot = []
      var priceCold = []
      var cold = []
      var hot = []
      var def = []
      var newPriceList = []
      var priceDefault = []
      for (var k = 0; k < priceList.length; k++) {
        var tag = 0
        for (var j = 0; j < priceList[k].length; j++) {
          var type = priceList[k][j][1]
          if (type === 41 || type === 42 || type === 43) {
            // cold
            priceCold.push(this.getElement(priceList[k], 2))
            cold.push(priceList[k])
            tag = 1
          } else if (type === 44 || type === 45 || type === 46 ||
                   type === 47 || type === 48 || type === 49
          ) {
            // hot
            priceHot.push(this.getElement(priceList[k], 2))
            hot.push(priceList[k])
            tag = 1
          }
        }
        if (tag === 0) {
          priceDefault.push(this.getElement(priceList[k], 2))
          def.push(priceList[k])
        }
      }
      for (var l = 0; l < priceList.length; l++) {
        for (var g = 0; g < priceList[l].length; g++) {
          var type2 = priceList[l][g][1]
          if (type2 === 41 || type2 === 42 || type2 === 43) {
            // cold
            if (this.getElement(priceList[l], 2) === Math.min.apply(Math, priceCold)) {
              newPriceList.push(priceList[l])
            }
          } else if (type2 === 44 || type2 === 45 || type2 === 46 ||
                   type2 === 47 || type2 === 48 || type2 === 49
          ) {
            // hot
            if (this.getElement(priceList[l], 2) === Math.min.apply(Math, priceHot)) {
              newPriceList.push(priceList[l])
            }
          } else {
            // default
            if (this.getElement(priceList[l], 2) === Math.min.apply(Math, priceDefault)) {
              newPriceList.push(priceList[l])
            }
          }
        }
      }
      var allMinPrice = []
      for (var c = 0; c < priceList.length; c++) {
        var allMin = 0
        for (var p = 0; p < priceList[c].length; p++) {
          if (priceList[c][p][2]) allMin = allMin + priceList[c][p][2]
        }
        allMinPrice.push(allMin)
      }
      this.minPrice[number] = Math.min.apply(Math, allMinPrice)
      if (this.showMenuIcon === 2 && newPriceList.length) {
        for (var n = 0; n < newPriceList.length; n++) {
          if (n === 0) {
            var noIconPriceList = []
            var noIconP = []
            var noIcon = newPriceList[n][0]
            noIconP.push(noIcon)
            noIconPriceList.push(noIconP)
            return noIconPriceList
          }
        }
      }
      // [] => name, temp_type,  , price,
      return newPriceList
    },
    parsePrice (number) {
      var pSchema = this.schema.product
      var cSchema = this.schema.combine
      var combinations = this.changeToProductList(number)[pSchema.combine_list]
      var combination = parse.divideList(combinations, this.changeToCombineList)
      var allMethods = []
      var buffer = []
      if (combinations) {
        this.loading.menu = false
        for (var q = 0; q < combination.length; q++) {
          buffer.push(parse.getCommons(combination[q][cSchema.common_list]))
        }
        for (var h = 0; h < buffer.length; h++) {
          for (var b = 0; b < buffer[h].length; b++) {
            allMethods.push(buffer[h][b])
          }
        }
        return allMethods
      }
    },
    getTempE (price, index) {
      return this.checkTemp(this.getElement(price, index))
    },
    checkTemp (temp) {
      // 不顯示任何溫度
      if (this.showMenuIcon === 2) {
        return 'text-light-gray'
      } else if (temp === 42) {
         // cold
        return 'text-blue'
      } else if (temp === 48) {
         // warm or hot
        return 'text-light-pink'
      } else if (temp === 40) {
        return 'text-light-pink'
      } else {
        // others
        if (!this.showMenuIcon) return 'text-light-gray'
        else return 'text-blue'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MenuLogic.vue?545e83f6